export default __webpack_public_path__ + "static/media/ep1quoteblockBg.6c676eb9.png";